import React from "react";
import { useTranslation } from "react-i18next";

export function buildWithdrawalSteps(status, submitTime, auditedTime, t) {
  const isRejected = status === 4;
  const isApproved = status === 3 || status === 5;
  const processingDone = isApproved || isRejected;

  return [
    {
      key: "submitted",
      label: t("WITHDRAWAL_STEP_SUBMITTED"),
      state: "done",
      time: submitTime || "",
    },
    {
      key: "processing",
      label: t("WITHDRAWAL_STEP_PROCESSING"),
      state: processingDone ? "done" : "current",
      time: "",
    },
    isRejected
      ? {
          key: "rejected",
          label: t("WITHDRAWAL_STEP_REJECTED"),
          state: "rejected",
          time: auditedTime || "",
        }
      : {
          key: "approved",
          label: t("WITHDRAWAL_STEP_APPROVED"),
          state: isApproved ? "done" : "upcoming",
          time: isApproved ? auditedTime || "" : "",
        },
  ];
}

function getLineState(step, nextStep) {
  if (!nextStep) {
    return "";
  }
  if (nextStep.state === "rejected") {
    return "rejected";
  }
  if (step.state === "done") {
    return "done";
  }
  return nextStep.state;
}

const WithdrawalStatusTimeline = ({ item, theme = "dark" }) => {
  const { t } = useTranslation();
  const steps = buildWithdrawalSteps(
    Number(item && item.approvalStatus),
    (item && item.submitTime) || "",
    (item && item.auditedTime) || "",
    t
  );

  return (
    <div className={`withdrawal-status-timeline withdrawal-status-timeline--${theme}`}>
      {steps.map((step, index) => {
        const nextStep = steps[index + 1];
        const lineState = getLineState(step, nextStep);
        return (
          <div
            key={step.key}
            className={`withdrawal-status-timeline__step withdrawal-status-timeline__step--${step.state}`}
          >
            <div className="withdrawal-status-timeline__rail">
              <span className="withdrawal-status-timeline__dot" />
              {nextStep && (
                <span
                  className={`withdrawal-status-timeline__line withdrawal-status-timeline__line--${lineState}`}
                />
              )}
            </div>
            <div className="withdrawal-status-timeline__content">
              <div className="withdrawal-status-timeline__label">{step.label}</div>
              {step.time ? (
                <div className="withdrawal-status-timeline__time">
                  {step.time.split(" ").map((part, partIndex) => (
                    <span
                      key={partIndex}
                      className="withdrawal-status-timeline__time-part"
                    >
                      {part}
                    </span>
                  ))}
                </div>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WithdrawalStatusTimeline;
